import ManagePortionParcels from './ManagePortionParcels'

export default ManagePortionParcels
